module.exports = __webpack_public_path__ + "static/media/uz.e0617195.svg";